import Card from '@components/Card';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import useToggleFavoritePrepaidCard from '@hooks/prepaidCard/useToggleFavoritePrepaidCard';
import EditFill from '@icons/edit/EditFill';
import TrashFill from '@icons/TrashFill';
import { UserPrepaidCardRow } from '@models/prepaidCard';
import { Link } from '@router/Link';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import useDeletePrepaidCard from './hooks/useDeletePrepaidCard';
import useUpdateName from './hooks/useUpdateName';
import LikeFillIcon from './LikeFillIcon';
import LikeIcon from './LikeIcon';
import styles from './styles.module.scss';

interface Props {
    prepaidCard: UserPrepaidCardRow;
}

function PrepaidCardItem({
    prepaidCard,
}:Props) {
    const { t } = useTranslation('prepaidCard');
    const {
        balance, imageUrl, id, createdAt, isFavorites,
    } = prepaidCard;
    const { handleDelete } = useDeletePrepaidCard({ id, balance });
    const { handleToggleFavorite } = useToggleFavoritePrepaidCard({ id, initialValue: prepaidCard.isFavorites });
    const Icon = isFavorites ? LikeFillIcon : LikeIcon;
    const { name, handleUpdateName } = useUpdateName({ id, initialValue: prepaidCard.name });
    return (
        <Row spacing={10} fullWidth align='flex-start'>
            <Icon size={30}
                color={colors.gray6}
                onClick={handleToggleFavorite} />
            <Link activityName='PrepaidCardLogActivity'
                activityParams={{ prepaidCardId: id }}
                className={styles.link} >
                <Card>
                    <Card.Body>
                        <Row spacing={16} align='flex-start'
                            fullWidth >
                            <Image src={imageUrl}
                                className={styles.image}
                                width={90}
                                height={60}
                                alt={name} />
                            <div className={styles.nameWrapper}>
                                <Text size='lg'
                                    fontWeight='bold'
                                    className={styles.name}>
                                    {name}
                                </Text>
                            </div>

                        </Row>
                        <Row fullWidth justify='flex-end'>
                            <Text size='xl' fontWeight='bold'>
                                {balance.toLocaleString()}{t('currencyUnit')}
                            </Text>
                        </Row>
                    </Card.Body>
                    <Card.Footer>
                        <Row justify='space-between' fullWidth
                            className={styles.footer} >
                            <Row>
                                <Text color={colors.gray6}>
                                    <b>{t('manage.registered')}</b>&nbsp;
                                    {dayjs(createdAt).format('YYYY.MM.DD HH:mm:ss')}
                                </Text>
                            </Row>
                            <Row>
                                <EditFill size={24}
                                    color={colors.gray4}
                                    onClick={handleUpdateName} />
                                <TrashFill size={24}
                                    color={colors.gray4}
                                    onClick={handleDelete} />
                            </Row>
                        </Row>
                    </Card.Footer>
                </Card>
            </Link>
        </Row>
    );
}

export default PrepaidCardItem;
